import type { JSX, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './TableauDefilant.module.css';

/**
 * Le cadre d'un tableau large : c'est LUI qui défile à l'horizontale, jamais la
 * page. Les boutons d'action d'une ligne restent atteignables en faisant
 * glisser le tableau, et au clavier (le cadre prend le focus : les flèches le
 * font défiler). Un tableau qui s'empile en cartes sur téléphone n'en a pas
 * besoin.
 */
export function TableauDefilant({
  children,
  libelle,
  empile = false,
}: {
  children: ReactNode;
  /** Le tableau s'empile en cartes sous 760 px : la largeur minimale ne vaut qu'au-delà. */
  empile?: boolean;
  /** Nom du tableau pour les lecteurs d'écran ; à défaut, un nom générique. */
  libelle?: string;
}): JSX.Element {
  const { t } = useTranslation('console');
  return (
    <div
      className={empile ? `${styles.cadre} ${styles.empile}` : styles.cadre}
      role="group"
      tabIndex={0}
      aria-label={libelle ?? t('commun.tableauDefilant')}
    >
      {children}
    </div>
  );
}
